import { type FC } from 'react';

import { type SeriaPlusScheme } from '../../settings/seriaPlusTypes';
import styles from './SeriaPlusDescriptions.css';

type SeriaPlusDescriptionsProps = {
  activeSlideIndex: number;
  activeTabIndex: number;
  tabs: SeriaPlusScheme['tabs'];
};

export const SeriaPlusDescriptions: FC<SeriaPlusDescriptionsProps> = props => {
  const { activeSlideIndex, activeTabIndex, tabs } = props;
  const activeSlide = tabs[activeTabIndex]?.slides[activeSlideIndex];

  if (!activeSlide) {
    return null;
  }

  return (
    <div className={styles['descriptions']}>
      {tabs.map((tab, tabIndex) =>
        tab.slides.map((slide, slideIndex) => {
          const isActive = tabIndex === activeTabIndex && slideIndex === activeSlideIndex;
          const descriptionClassName = isActive
            ? styles['description']
            : `${styles['description']} ${styles['description--hidden']}`;
          const descriptionLines = slide.descriptionLines || [slide.description];

          return (
            <p
              aria-hidden={isActive ? undefined : true}
              className={descriptionClassName}
              data-testid={isActive ? 'seria-plus-description' : undefined}
              hidden={!isActive}
              key={`${tab.id}-${slide.id}`}
            >
              {descriptionLines.map((line, lineIndex, lines) => (
                <span className={styles['description-line']} key={lineIndex}>
                  {line}
                  {lineIndex < lines.length - 1 ? ' ' : null}
                </span>
              ))}
            </p>
          );
        }),
      )}
    </div>
  );
};
